import React from 'react';
import PropTypes from 'prop-types';
import {withStyles, createStyleSheet} from 'material-ui/styles';
import List, {ListItem, ListItemText} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';

const styleSheet = createStyleSheet('ImageAvatars', {
  // avatar: {
  //   width: 67,
  //   height: 67,
  // },
  list: {
    textAlign: 'left',
    paddingTop: 4,
    paddingBottom: 4,
  },
});

function ClrList({list, classes, handleClick}) {

  return <List>
    {list.map((value, ind) =>
      <ListItem button className={classes.list} key={ind} onClick={() => handleClick(value.image)}>
        <Avatar alt={value.text} src={value.image} className={classes.avatar}/>
        <ListItemText primary={value.text}/>
      </ListItem>,
    )}
  </List>;

};
ClrList.propTypes = {
  list: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default withStyles(styleSheet)(ClrList);


// WEBPACK FOOTER //
// ./src/ClrSelect/ClrList.js